import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { CommonDataService } from '../../services/common-data.service';
import { ValidationService } from '../../services/validation.service';
import { Router } from '@angular/router';
import { constObj } from '../../Constants/constants';
import { HttpcallService } from '../../services/httpcall.service';
import { User } from '../../../components/access-management/access-management.component';
import { CryptionService } from '../../services/cryption.service';
import { SessionService } from '../../services/Session.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();

  constructor(
    private session: SessionService,
    private graphQlService: GraphqlService,
    private loginService: LoginService,
    public commonDataService: CommonDataService,
    private validationService: ValidationService,
    private httpCallService: HttpcallService,
    private cryption: CryptionService,
    private graphQLService: GraphqlService,
    private router: Router) {
  }

  userForm = new FormGroup({
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    email: new FormControl(''),
    password: new FormControl(''),
    admin: new FormControl(false)
  })
  isHomePage: boolean = false;
  firstnameError: any;
  lastnameError: any;
  emailError: any;
  passwordError: any;
  userData: any;
  cryptionKey: string = "";
  cryptionIv: string = "";
  outcome: boolean = false;
  ngOnInit(): void {
    if (this.router.url.includes("Home")){
      this.isHomePage = true;
      this.userForm.controls.firstname.disable();
      this.userForm.controls.lastname.disable();
      this.userForm.controls.email.disable();
    }
    this.userData = null;
    if (this.session.globallablesinfo == null || this.session.globallablesinfo == undefined) {
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != "") {
          this.getUserLabel(data);
          this.session.assignglobalinfo(data);
          this.commonDataService.showLoader.next(false);
          this.outcome = true;
        }
      });
    }
    else {
      this.getUserLabel(this.session.globallablesinfo);
      this.commonDataService.showLoader.next(false);
      this.outcome = true;
    }
    this.checkSession();
    this.graphQLService.getCryptionKeys().subscribe(data => {
      if (data != null) {
        this.cryptionKey = data.split("~~~~")[0];
        this.cryptionIv = data.split("~~~~")[1];
      }
    })
    this.commonDataService.userData.subscribe(data => {
      if (data != null) {
        this.userData = data;
        this.userForm.setValue({
          firstname: this.userData.firstname,
          lastname: this.userData.lastname,
          email: this.userData.email,
          password: "",
          admin: this.userData.isAdmin,
        });
      }
      else {
        this.userData = null;
      }
    })
  }
  closeOverlayButton() {
    this.closeOverlay();

  }

  userInfo
  checkSession() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.userInfo = data.user;
      })
    }
    else {
      this.userInfo = this.session.userInfo.user;
    }
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }

  addUser() {
    if (this.checkValidations()) {
      this.commonDataService.showLoader.next(true);
      if (this.userData == null) {
        let addUser: User = {
          Id: '-1', FirstName: this.userForm.value.firstname,
          LastName: this.userForm.value.lastname, Email: this.userForm.value.email, CreatedBy: this.userInfo.email, ModifiedBy: this.userInfo.email,
          Password: this.cryption.encryptUsingAES256(this.userForm.value.password, this.cryptionKey, this.cryptionIv).toString(), IsAdmin: this.userForm.value.admin, IsActive: true
        }
        this.httpCall(addUser, "add");
      }
      else {
        if (this.isHomePage) {
          let editUser: User = {
            Id: this.userData.id, FirstName: this.userData.firstname,
            LastName: this.userData.lastname, Email: this.userData.email, CreatedBy: "", ModifiedBy: this.userData.email,
            Password: (this.userForm.value.password == null || this.userForm.value.password == "") ? null : this.cryption.encryptUsingAES256(this.userForm.value.password, this.cryptionKey, this.cryptionIv).toString(),
            IsAdmin: this.userData.isAdmin, IsActive: true
          }
          this.httpCall(editUser, "edit");
        }
        else {
          let editUser: User = {
            Id: this.userData.id, FirstName: this.userForm.value.firstname,
            LastName: this.userForm.value.lastname, Email: this.userForm.value.email, CreatedBy: "", ModifiedBy: localStorage.getItem("email"),
            Password: (this.userForm.value.password == null || this.userForm.value.password == "") ? null : this.cryption.encryptUsingAES256(this.userForm.value.password, this.cryptionKey, this.cryptionIv).toString(),
            IsAdmin: this.userForm.value.admin, IsActive: true
          }
          this.httpCall(editUser, "edit");
        }
      }
    }
  }

  checkValidations() {
    let isEmailValid = this.checkEmail();
    let isFirstNameValid = this.checkFirstNameContent();
    let isLastNameValid = this.checkLastNameContent();
    let isPasswordValid = (this.isHomePage) ? this.checkPasswordContent() : (this.userData == null || this.userData?.id == null ? this.checkPasswordContent() : true);
    return isEmailValid && isFirstNameValid && isPasswordValid && isLastNameValid;
  }

  emailLabel: any;
  emailValid: boolean = true;
  isFirstNameContentValid: boolean = true;
  isLastNameContentValid: boolean = true;
  isPasswordContentValid: boolean = true;
  checkEmail(): boolean {
    this.emailValid = true;
    let email = this.userForm.controls.email;

    if (!this.validationService.validateRequiredField(email) || email.value.trim() == "") {
      this.emailError = this.emailLabelForm + this.validationService.getErrorMessage('required', this.userForm.controls.email.value, null);
      email.markAsTouched();
      this.emailValid = false
    }

    else if (!this.validationService.validateEmailformat(email.value)
      || !this.validationService.validateEmailfullformat(email.value)
      || !this.validationService.validatemailpostionRegexformat(email.value)
      || !this.validationService.validateEmailspecialCharformat(email.value)) {
      this.emailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      this.emailValid = false
    }

    if (this.emailValid) {
      this.emailError = "";
    }

    return this.emailValid;
  }

  httpCall(user: User, operation: string) {
    this.httpCallService.addUpdateUser(user).toPromise()
      .then(response => {
        if (response.includes("rows affected.")) {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: (operation == "add") ? constObj.userAddedSuccessMessage : ((this.userInfo.email == user.Email) ? ((user.Password != null) ? (constObj.passwordReset) : (constObj.adminDetailsUpdate)) : constObj.userEditedSuccessMessage)
          }
          this.commonDataService.notificationObject.next(obj);
          this.commonDataService.userAddedUpdated.next(true);
          //if (operation == "add") {
          //this.commonDataService.addAnnotationParagraphId.next(annotation.paragraphId);
          this.closeOverlayButton();
          if ((this.userInfo.email == user.Email)) {
            localStorage.removeItem("DefaultSecView");
            localStorage.removeItem("ElasticSearchTerm");
            setTimeout(() => {
              window.location.href = "/Login/proViewLogin";
            },
              2000);
          }
          //}
          //else {
          //  this.commonDataService.annotationUpdateSource.subscribe(data => {
          //    this.commonDataService.updateAnnotationParagraphId.next(annotation.paragraphId);
          //    if (data == "Your Annotation") {
          //      this.commonDataService.rightOverlayOption.next("Your Annotations");
          //    }
          //    else {
          //      this.commonDataService.myannotation.next("annotations");
          //      this.closeOverlay();
          //    }
          //  })
          //}
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: (operation == "add") ? constObj.userAddedFailMessage : constObj.userEditedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }

  checkPasswordContent() {
    this.isPasswordContentValid = true;
    if (!this.validationService.validateRequiredField(this.userForm.controls.password.value) || this.userForm.controls.password.value.trim() == "") {
      this.passwordError = this.passwordlabel + this.validationService.getErrorMessage('required', this.userForm.controls.password.value, null);
      this.userForm.controls.password.markAsTouched();
      this.isPasswordContentValid = false
    }


    if (this.isPasswordContentValid) {
      this.passwordError = '';
    }

    return this.isPasswordContentValid;
  }

  checkFirstNameContent() {
    this.isFirstNameContentValid = true;
    if (!this.validationService.validateRequiredField(this.userForm.controls.firstname.value) || this.userForm.controls.firstname.value.trim() == "") {
      this.firstnameError = this.firstnameLabel + this.validationService.getErrorMessage('required', this.userForm.controls.firstname.value, null);
      this.userForm.controls.firstname.markAsTouched();
      this.isFirstNameContentValid = false
    }

    if (this.isFirstNameContentValid) {
      this.firstnameError = '';
    }
    return this.isFirstNameContentValid;
  }

  checkLastNameContent() {
    this.isLastNameContentValid = true;
    if (!this.validationService.validateRequiredField(this.userForm.controls.lastname.value) || this.userForm.controls.lastname.value.trim() == "") {
      this.lastnameError = this.lastnameLabel + this.validationService.getErrorMessage('required', this.userForm.controls.lastname.value, null);
      this.userForm.controls.lastname.markAsTouched();
      this.isLastNameContentValid = false
    }
    if (this.isLastNameContentValid) {
      this.lastnameError = '';
    }
    return this.isLastNameContentValid;
  }
  addUserLabel;
  updateUserLabel;
  firstnameLabel;
  lastnameLabel;
  emailLabelForm;
  passwordlabel;
  isUserAdminLabel;
  addbuttonLabel;
  updateButtonLabel;
  getUserLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.addUserLabel = labels.filter(x => x.key == "addUserLabel").map(y => y.value);
      this.updateUserLabel = labels.filter(x => x.key == "updateUserLabel").map(y => y.value);
      this.firstnameLabel = labels.filter(x => x.key == "firstnameLabel").map(y => y.value);
      this.lastnameLabel = labels.filter(x => x.key == "lastnameLabel").map(y => y.value);
      this.emailLabelForm = labels.filter(x => x.key == "emailLabel").map(y => y.value);
      this.passwordlabel = labels.filter(x => x.key == "passwordLabel").map(y => y.value);
      this.isUserAdminLabel = labels.filter(x => x.key == "isuserAdminLabel").map(y => y.value);
      this.addbuttonLabel = labels.filter(x => x.key == "global_add").map(y => y.value);
      this.updateButtonLabel = labels.filter(x => x.key == "global_update").map(y => y.value);
      this.commonDataService.showLoader.next(false);
    }
  }
}
